import { useOutletContext } from "react-router-dom";
import { AccountData } from "../../../api/Requests";
import { useAuth } from "../../../auth/AuthProvider";
import { FcGoogle } from "react-icons/fc";

export default function Account() {
  const { session } = useAuth();
  const accountData = useOutletContext<AccountData>();
  const googleId = session?.user.identities?.find(
    ui => ui.provider === "google",
  );
  const profileImg = session?.user.user_metadata?.picture;

  return (
    <div className="pageContainer">
      <h1>Account</h1>
      {!!accountData && (
        <div className="pageItem">
          <p>
            <b>Account Email</b> {session?.user.email}
          </p>
          <p>
            <b>Account Confirmed </b>
            {session?.user.confirmed_at ? (
              <b style={{ color: "green" }}>Yes</b>
            ) : (
              <b style={{ color: "red" }}>No</b>
            )}
          </p>
          {googleId && (
            <span style={{ display: "flex", alignItems: "center" }}>
              <FcGoogle />
              <p style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                <b>Google Auth</b> <b style={{ color: "green" }}>Connected</b>
              </p>
              {profileImg && (
                <img
                  src={profileImg}
                  alt="profile pic"
                  width={"20px"}
                  style={{
                    borderRadius: "50%",
                    objectFit: "cover",
                    height: "20px",
                  }}
                />
              )}
            </span>
          )}
          <p>
            <b>Account Created</b>{" "}
            {session?.user.created_at &&
              new Date(session.user.created_at).toLocaleString("en-US", {
                dateStyle: "full",
              })}
          </p>
          <p>
            <b>Subscription Tier</b>{" "}
            {accountData.account.subscriptionTier || "starter"}
          </p>
          <p>
            <b>Subscription Interval</b>{" "}
            {accountData.account.subscriptionInterval || "-"}
          </p>
          <p>
            <b>Subscription Status</b> {accountData.account.subscriptionStatus}
          </p>
          <p>
            <b>Subscription Start Date</b>{" "}
            {accountData.account.subscriptionStartedOn &&
              new Date(
                accountData.account.subscriptionStartedOn,
              ).toLocaleString("en-US", {
                dateStyle: "full",
              })}
          </p>
          <p>
            <b>Subscription Last Updated</b>{" "}
            {accountData.account.subscriptionUpdatedOn &&
              new Date(
                accountData.account.subscriptionUpdatedOn,
              ).toLocaleString("en-US", {
                dateStyle: "full",
              })}
          </p>
        </div>
      )}
    </div>
  );
}
